export enum GoogleAnalyticsEventNames {
  PAGE_VIEW = 'page_view',
}
